/* ============================================================================
   DexConfigSyncer - loads the admin-set dex config from the Worker once.
   ----------------------------------------------------------------------------
   A render-null bridge that calls useDexConfig() so the app fetches
   GET /api/dex-config near launch and merges the admin's curated-roster
   (mega/gmax/dynamax) + release overrides onto the bundled baseline (via
   setRuntimeCuratedRosterOverrides / setRuntimeReleaseOverrides inside the hook).

   Mounted as a sibling of ShadowRosterSyncer inside QueryClientProvider — the
   GET endpoint is public, so it runs for signed-out users too and never blocks
   render. Until it resolves, consumers run on the bundled baseline.
============================================================================ */
import { useDexConfig } from "@/hooks/useDexConfig";

export function DexConfigSyncer() {
  useDexConfig();
  return null;
}
